import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sentInvoiceOrg", "billingContentCode", "applyDescription"]

  connect() {
    this.handleBillingContentCodeChange = this.handleBillingContentCodeChange.bind(this)
    this.handleSentInvoiceOrgChange = this.handleSentInvoiceOrgChange.bind(this)
    this.billingContentCodeTarget.addEventListener('change', this.handleBillingContentCodeChange)
    this.sentInvoiceOrgTarget.addEventListener('change', this.handleSentInvoiceOrgChange)

    this.updateApplyDescription()
  }

  disconnect() {
    this.billingContentCodeTarget.removeEventListener('change', this.handleBillingContentCodeChange)
    this.sentInvoiceOrgTarget.removeEventListener('change', this.handleSentInvoiceOrgChange)
  }

  handleBillingContentCodeChange() {
    this.updateApplyDescription()
  }

  handleSentInvoiceOrgChange(event) {
    this.updateApplyDescription()
    if (!event.target.value) return

    const url = new URL("/financial_analysis/other_billing_and_inquiries/sent_invoice_org_change", window.location.origin)
    url.searchParams.set("sent_invoice_org_code", event.target.value)
    $.ajax(url.toString(), { dataType: "script" })
  }

  updateApplyDescription() {
    if (this.billingContentCodeTarget.value === "S00004") {
      this.applyDescriptionTarget.value = "设计咨询费"
      this.applyDescriptionTarget.readOnly = true
    } else if (this.billingContentCodeTarget.value === "S00025" && this.sentInvoiceOrgTarget.value === "000117") {
      this.applyDescriptionTarget.value = "S00025"
      this.applyDescriptionTarget.readOnly = true
    } else {
      if (this.applyDescriptionTarget.value === "设计咨询费" || this.applyDescriptionTarget.value === "S00025") {
        this.applyDescriptionTarget.value = ""
      }
      this.applyDescriptionTarget.readOnly = false
    }
  }
}
